module.exports = ".th-width-align{\n  width: 20px;\n  text-align: center;\n}\n\n:host ::ng-deep .mat-tab-header {\n  top: 0;\n  z-index: 1000;\n  position: sticky;\n  background-color: white;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/partners/partners.component.css
// module id = ./src/app/partners/partners.component.css
// module chunks = main